<template>
  <div>
    <BaseTitle :title="$t('content.announcement')" :yearPeriode="titleData" />

    <v-card>
      <div>
        <div class="pa-5 d-flex justiy-space-between align-items section-header active">
          <div class="student-title">{{ $t('content.announcement') }}</div>
        </div>
        <div class="ml-5 mt-3 mr-5">
          <div class="d-flex align-center justify-space-between">
            <div>
              <v-btn
                color="primary"
                class="btn-primary-custom mb-2 mb-md-0 mr-md-2"
                @click="addAnnouncement()"
                v-if="
                  (isStudent === false && permissionButton('ROLE_ANNOUNCEMENT_VIEW')) ||
                    (isStudent === false && permissionButton('ROLE_ANNOUNCEMENT_LITE_VIEW'))
                "
                >{{ $t('add') }}</v-btn
              >
            </div>

            <v-progress-circular class="text-center" v-if="loadingLoad === true" indeterminate color="primary"></v-progress-circular>
            <div>
              <v-text-field v-model="search" :label="$t('search')" @input="getData">
                <template #prepend-inner>
                  <svg-icon icon="ic-search" class="primary--text mr-3" />
                </template>
              </v-text-field>
            </div>
          </div>
        </div>
        <div class="border-item" v-for="item in datas" :key="item.announcementId">
          <v-row v-if="item.inDate === true && lengthDatas > 0">
            <v-col md="1" align="center">
              <div class="mt-5 ml-5">
                <svg-icon icon="megaphone" width="30" height="30" class="primary--text" />
                <v-divider vertical></v-divider>
              </div>
            </v-col>
            <v-col md="10" class="mt-3">
              <div class="d-block">
                <h3 class="d-inline">
                  <span class="header-content">{{ item.title }} </span>
                </h3>
              </div>
              <div class="d-block">
                <div>
                  <span class="body-content">
                    <span class="mr-3">
                      {{ $t('form.date') }} :
                      <strong>{{ item.date }}</strong>
                    </span>
                    |
                    <span class="mr-3">
                      {{ $t('content.by') }} :
                      <strong>{{ item.by }}</strong>
                    </span>
                  </span>
                </div>
              </div>
              <div class="d-flex"></div>
            </v-col>
            <v-col md="1">
              <template>
                <div class="pa-5">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <span dark v-bind="attrs" v-on="on">
                        <svg-icon icon="ic-moreaction-black" class="mt-1" />
                      </span>
                    </template>
                    <v-list>
                      <v-list-item v-if="permissionButton('ROLE_ANNOUNCEMENT_VIEW') || permissionButton('ROLE_ANNOUNCEMENT_LITE_VIEW')">
                        <v-list-item-title class="text-dropdown" @click="goView(item.announcementId)">{{ $t('view') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="
                          (isStudent === false && permissionButton('ROLE_ANNOUNCEMENT_UPDATE')) ||
                            (isStudent === false && permissionButton('ROLE_ANNOUNCEMENT_LITE_UPDATE'))
                        "
                      >
                        <v-list-item-title class="text-dropdown" @click="goEdit(item.announcementId)">{{ $t('edit') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="
                          (item.deleteable === true && isStudent === false && permissionButton('ROLE_ANNOUNCEMENT_DELETE')) ||
                            (item.deleteable === true && isStudent === false && permissionButton('ROLE_ANNOUNCEMENT_LITE_DELETE'))
                        "
                      >
                        <v-list-item-title class="text-dropdown-delete" @click="goDelete(item)">{{ $t('table.delete') }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </template>
            </v-col>
            <!-- Dialog Delete -->
            <v-dialog v-model="dialogDelete" persistent max-width="290">
              <v-card>
                <v-card-title class="headline">{{ $t('delete_title') }}</v-card-title>
                <v-card-text>{{ $t('delete_message') }}</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="dialogDelete = false">{{ $t('disagree') }}</v-btn>
                  <v-btn text @click="deleteDetail">{{ $t('aggree') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </div>
        <NoData v-if="!lengthDatas" />
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import NoData from '@/components/table/NoData';
import moment from 'moment-timezone';

export default {
  name: 'AnnouncementIndex',
  components: {
    BaseTitle,
    NoData
  },
  props: {
    isClass: {
      type: Boolean,
      default: false
    },
    isStudent: {
      type: Boolean,
      default: false
    },
    isParent: {
      type: Boolean,
      default: false
    }
  },
  sockets: {
    connect() {
      console.log('socket connected');
    },
    announcement({ classId, courseId }) {
      const { classId: currentClassId, courseId: currentCourseId } = this.$route.params;
      if (classId == currentClassId && courseId == currentCourseId) {
        this.$store.dispatch('general/showSuccessNotification', { message: 'Update List Announcement' });
        setTimeout(() => {
          this.getData();
        }, 400);
      }
    }
  },
  computed: {
    ...mapGetters({
      course: 'QuizTeacher/courses',
      classLevel: 'QuizTeacher/classLevel',
      permission: 'Auth/permission',
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    })
  },
  data: () => ({
    loadingButton: false,
    dialogDelete: false,
    loadingLoad: false,
    dataClass: '',
    datas: '',
    search: '',
    currentItem: '',
    gmt: '',
    lengthDatas: 0,
    titleData: ''
  }),
  methods: {
    getProfile() {
      this.$store.dispatch('User/fetchProfile').then(res => {
        if (res.gmt === null) {
          this.gmt = 'Asia/Jakarta';
        } else {
          this.gmt = res.gmt;
        }
      });
    },
    permissionButton(push) {
      return this.permission.some(p => p === push) ?? false;
    },
    getDataClass() {
      if (!this.$route.params.classSectionId) {
        this.$store
          .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
          .then(res => {
            if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
              this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            } else {
              this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            }
          });
      } else {
        this.$store.dispatch('ClassSection/getListDetail', { classSectionId: this.$route.params.classSectionId }).then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res.classroomName + ` ${res.numberClass}` + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
      }
    },
    getData() {
      this.loadingLoad = true;
      this.$store
        .dispatch('Announcement/getDataAll', {
          classroomId: this.$route.params.classId,
          courseId: this.$route.params.courseId,
          classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : '',
          search: this.search
        })
        .then(res => {
          if (res) {
            res.forEach(datas => {
              if (datas.date && this.isStudent === true) {
                var future = moment(datas.date, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm');
                if (this.gmt) {
                  var convertAwal = moment()
                    .tz(this.gmt)
                    .format('YYYY-MM-DD HH:mm');
                } else {
                  convertAwal = moment().format('YYYY-MM-DD HH:mm');
                }
                var convertAkhir = moment(future).format('YYYY-MM-DD HH:mm');
                if (convertAwal >= convertAkhir) {
                  datas.inDate = true;
                } else {
                  datas.inDate = false;
                }
              } else {
                datas.inDate = true;
              }
            });
            this.datas = res;
            this.lengthDatas = res.filter(x => {
              return x.inDate;
            }).length;
          }
        })
        .finally(() => {
          this.loadingLoad = false;
        });
    },
    addAnnouncement() {
      if (this.isClass && !this.isStudent) {
        if (!this.$route.params.classSectionId) {
          this.$router.push({ name: 'AnnouncementCreateClass' });
        } else {
          this.$router.push({ name: 'AnnouncementSectionCreateClass' });
        }
      } else if (this.isClass && this.isStudent) {
        this.$router.push({ name: 'AnnouncementStudentCreateClass' });
      } else {
        this.$router.push({ name: 'AnnouncementCreate' });
      }
    },
    getCourse() {
      this.$store.dispatch('QuizTeacher/fetchClassLevelOrCourse', this.form.gradeId);
    },
    goView(id) {
      if (!this.isClass) {
        this.$router.push({ name: 'AnnouncementView', params: { id } });
        return;
      }

      if (!this.isStudent) {
        const name = this.$route.params.classSectionId ? 'AnnouncementSectionViewClass' : 'AnnouncementViewClass';
        this.$router.push({ name, params: { id } });
        return;
      }

      const name = this.isParent ? 'AnnouncementParentViewClass' : 'AnnouncementStudentViewClass';
      this.$router.push({ name, params: { id } });
    },
    goEdit(id) {
      if (this.isClass && !this.isStudent) {
        if (!this.$route.params.classSectionId) {
          this.$router.push({ name: 'AnnouncementEditClass', params: { id } });
        } else {
          this.$router.push({ name: 'AnnouncementSectionEditClass', params: { id } });
        }
      } else {
        this.$router.push({ name: 'AnnouncementEdit', params: { id } });
      }
    },
    goDelete(item) {
      this.dialogDelete = true;
      this.currentItem = item.announcementId;
    },
    deleteDetail() {
      if (!this.currentItem) return false;

      this.loadingButton = true;
      this.$store
        .dispatch('Announcement/destroy', this.currentItem)
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.currentItem = null;
          this.getData();
          this.dialogDelete = false;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loadingButton = false));
    }
  },
  created() {
    this.getData();
    if (this.isClass) {
      this.getDataClass();
    } else {
      localStorage.removeItem('courseName');
    }
  }
};
</script>

<style lang="scss" scoped>
.assignment {
  &-title {
    font-family: Montserrat;
    font-weight: bold;
    color: #6d6d6d;
    font-size: 18px;
  }

  &-head {
    font-family: Montserrat;
    font-weight: bold;
    color: #6d6d6d;
    font-size: 16px;
  }

  &-content {
    margin: 10px 20px 20px 20px;

    font-family: Montserrat;
    line-height: 16px;
    font-size: 12px;
  }
}
.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
.section-footer {
  border-radius: 4px 4px 0 0;
  background: #e7f5ff;
}
.header-circle {
  background-color: #00bf63;
  border: 1px solid #ffffff;
  border-radius: 8px;
  width: 110px;
  height: 23px;
}
.header-circle-text {
  color: #ffffff;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  margin-left: 10px;
}
.border-item {
  border-bottom: 1px solid #dedede;
}
.assignment-item {
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  border-bottom: 1px solid #dedede;
  // &:last-child {
  //   border-bottom: 0;
  //   // border-bottom: 1px solid #dedede;
  // }

  &-icon {
    width: 24px;
    height: 24px;
    border-radius: 8px;
    background: #fff0da;
    color: #f1b65a;
    text-align: center;
    line-height: 24px;
    margin-right: 12px;

    svg {
      margin-top: 3px;
    }
  }

  &-section {
    margin-bottom: 15px;

    &:last-child {
      margin-bottom: 0;
    }

    &-title {
      display: block;
    }

    strong {
      color: #6d6d6d;
    }
  }

  @include query-min-sm() {
    flex-direction: row;
    align-items: center;

    &-section {
      flex-basis: 25%;
      margin-bottom: 0;
    }
  }
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
  &-grey {
    color: grey;
    cursor: pointer;
  }
}

.attendance-scroller {
  overflow-x: scroll;
  overflow-y: visible;
}

.attendance-table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;

  th {
    padding: 10px;
    text-align: left;
    color: #fff;
  }

  td {
    padding: 0px 13px;
    height: 50px;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    background: #fff;

    &:not(.attendance-sticky) {
      font-weight: bold;
      cursor: pointer;

      &:hover {
        background: #f8f8f8;
      }
    }
  }

  thead {
    tr {
      th {
        $height: 100px;
        height: $height;
        background: #00bf63;

        div {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;

          button {
            position: absolute;
            top: -5px;
            right: 0;
          }
        }
      }
    }
  }
}

.user {
  &-photo {
    width: 48px;
    height: 48px;
    overflow: hidden;
    border-radius: 100px;
    margin-right: 10px;
  }
}

.assigment-icon {
  width: 30px;
  height: 30px;
}

.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}

.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}

.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
</style>
